<template>
  <div class="account-page">
    <div class="account-left">
      <div class="account-card">
        <div class="account-profile">
          <div class="account-avatar">默认</div>
          <div>
            <div class="account-name">{{ userStore.userName }}</div>
            <div class="account-id">ID：#000001</div>
          </div>
        </div>

        <div class="account-fields">
          <div class="field">
            <span class="label">安全手机号</span>
            <span class="value">+86 **** 0000</span>
          </div>
          <div class="field">
            <span class="label">安全邮箱</span>
            <span class="value muted">未绑定</span>
          </div>
          <div class="field">
            <span class="label">注册时间</span>
            <span class="value">2026-01-01 10:00:00</span>
          </div>
          <div class="field">
            <span class="label">算力余额</span>
            <span class="value">{{ userStore.userInfo?.balance ?? '--' }}</span>
          </div>
        </div>
      </div>

      <div class="account-card">
        <div class="card-title small">快捷入口</div>
        <div class="quick-actions">
          <button class="ghost-btn" @click="router.push('/docs')">使用文档</button>
        </div>
      </div>
    </div>

    <div class="account-right">
      <div class="account-card">
        <div class="card-title small">登录与安全</div>
        <ul class="login-list">
          <li>
            <span class="label">账号密码</span>
            <span class="status ok">已设置</span>
          </li>
          <li>
            <span class="label">绑定手机</span>
            <span class="status ok">已绑定</span>
          </li>
          <li>
            <span class="label">绑定邮箱</span>
            <span class="status warn">未绑定</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/useAuthStore'

const router = useRouter()
const userStore = useAuthStore()
</script>
